import { render } from "./MultiSelect.vue?vue&type=template&id=671c0d5c&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=671c0d5c&scoped=true&lang=css"

import exportComponent from "/opt/doctorsp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671c0d5c"]])

export default __exports__